module.exports = __webpack_public_path__ + "img/solution.a23c3818.svg";